export default __webpack_public_path__ + "static/media/2.66881908.png";